import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import { PrimaryButton, SecondaryButton } from '@components/Button/variants';
import Byline from '@components/Byline';
import EventShowPage from '@components/pages/Events/EventShowPage/index';
import Footer from '@components/Footer/index';
import FieldLabel from '@components/Form/FieldLabel';
import IconClose from '@components/Images/Rebranding/IconClose';
import IconFacebook from '@components/Images/Rebranding/IconFacebook';
import IconOrgChart from '@components/Images/Rebranding/IconOrgChart';
import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';
import IconTI from '@components/Images/Rebranding/IconTI';
import IconTheWeekend from '@components/Images/Rebranding/IconTheWeekend';
import IconThreads from '@components/Images/Rebranding/IconThreads';
import IconX from '@components/Images/Rebranding/IconX';
import LogoTIProWithIconTI from '@components/Images/Rebranding/LogoTIProWithIconTI';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import MarketingLeadCaptureWithGoogle from '@components/OAuthButtons/MarketingLeadCaptureWithGoogle';
import MarketingLeadCaptureWithApple from '@components/OAuthButtons/MarketingLeadCaptureWithApple';
import MarketingModal from '@components/MarketingModal/index';
import ForYou from '@components/pages/ForYou/index';
import Nav from '@components/Nav/index';
import ProExclusiveLogo from '@components/ProExclusiveLogo/index';
import SocialLinks from '@components/SocialLinks/index';
import CustomSpinner from '@components/Spinner/CustomSpinner';
import ScoopsPage from '@components/Scoops';
import SlimNav from '@components/Nav/SlimNav';
import StickyBannerBottom from '@components/StickyBanner/Bottom';
import StickyBannerTop from '@components/StickyBanner/Top';
import StickyBannerUserStatus from '@components/StickyBanner/Top/UserStatus';
import TIHeader from '@components/TIHeader';
import UpdateProfileModal from '@components/UpdateProfileModal/index';
import VerticalAdvertisement from '@components/FeaturedPartnerAd/Vertical';
import BannerAdvertisement from '@components/FeaturedPartnerAd/Banner';
import ViewInAppModal from '@components/ViewInAppModal/index';
import TopicForumPosts from '@components/pages/Forum/TopicForumPosts/index';
import DualSubscribe from '@components/pages/DualSubscribe/index';
import AITopBanner from '@components/Banner/AITopBanner';
import TITVPopout from '@components/TITVPopout/index';
import GiftLandingForLead from '@components/pages/GiftLandingForLead/index';
import GiftPaymentConfirmation from '@components/pages/GiftPaymentConfirmation/index';
import SharePersonalBriefing from '@components/pages/SharePersonalBriefing/index';
import UserOnboardingModal from '@components/UserOnboardingModal/index';
import UserOnboardingTooltip from '@components/UserOnboardingTooltip/index';

import "../../window_setup"
import {
  setupAnalytics,
} from '../../application/javascripts/analytics_util';
import '../../application/javascripts/anchor-link';

registerWithErrorBoundary({
  AITopBanner,
  BannerAdvertisement,
  Byline,
  CustomSpinner,
  DualSubscribe,
  FieldLabel,
  EventShowPage,
  Footer,
  ForYou,
  IconClose,
  IconFacebook,
  IconOrgChart,
  IconProTagArticle,
  IconTheWeekend,
  IconThreads,
  IconTI,
  IconX,
  MarketingLeadCaptureWithGoogle,
  MarketingLeadCaptureWithApple,
  LogoTIProWithIconTI,
  LogoTIWithIconTI,
  MarketingModal,
  Nav,
  PrimaryButton,
  ProExclusiveLogo,
  ScoopsPage,
  SecondaryButton,
  SharePersonalBriefing,
  SlimNav,
  SocialLinks,
  StickyBannerBottom,
  StickyBannerTop,
  StickyBannerUserStatus,
  TIHeader,
  TopicForumPosts,
  UpdateProfileModal,
  VerticalAdvertisement,
  ViewInAppModal,
  TITVPopout,
  GiftLandingForLead,
  GiftPaymentConfirmation,
  UserOnboardingModal,
  UserOnboardingTooltip,
});

setupAnalytics();
